(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay/assets/javascripts/dialogs/confirm-payment.js') >= 0) return;  svs.modules.push('/components/tur/pay/assets/javascripts/dialogs/confirm-payment.js');

'use strict';

const currency = svs.utils.format.Currency;

function confirmPayment(_ref) {
  let next = _ref.next,
    cancel = _ref.cancel,
    accountBalance = _ref.accountBalance,
    isSyndicate = _ref.isSyndicate,
    syndicate = _ref.syndicate,
    price = _ref.price,
    title = _ref.title,
    _ref$messages = _ref.messages,
    messages = _ref$messages === void 0 ? [] : _ref$messages,
    product = _ref.product,
    isProlongation = _ref.isProlongation;
  let customer = 'Ditt';
  if (isSyndicate) {
    customer = svs.tur.pay.utils.format_text.addOwningGrammarApostrophe(syndicate.syndicateName || 'Laget');
  }
  messages.push("".concat(customer, " saldo: ").concat(currency(accountBalance), " kr"));
  const message = messages.map(text => ({
    type: svs.ui.dialog.message.TEXT,
    align: svs.ui.dialog.message.align.CENTER,
    text
  }));
  const onPopState = () => {
    dialog.close();
    cancel();
    window.removeEventListener('popstate', onPopState);
  };
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'games',
    title,
    message,
    actions: [{
      title: isProlongation ? 'Ändra' : 'Avbryt',
      callback: () => {
        dialog.close();
        if (product) {
          svs.components.analytics.trackEvent({
            category: 'betslip_cancelled',
            action: 'yes',
            opt_label: product
          });
        }
        window.removeEventListener('popstate', onPopState);
        cancel();
      }
    }, {
      title: "Betala ".concat(price, " kr"),
      callback: () => {
        dialog.close();
        window.removeEventListener('popstate', onPopState);
        next();
      }
    }]
  });
  window.addEventListener('popstate', onPopState);
  svs.ui.dialog.api.add(dialog);
}
svs.tur.pay.dialogs.confirmPayment = confirmPayment;

 })(window);